export class CsvUploadResult {
  constructor(public pro: string, public status: string) {}
}
